import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export const useTrackAssetModalInfoPanelClose = () => {
  const { track } = useAnalyticsUtilities();

  const trackAssetModalInfoPanelClose = useCallback(() => {
    track(`Closed asset modal info panel`);
  }, [track]);

  return { trackAssetModalInfoPanelClose };
};
